import React from 'react';

const CustomCheckbox = ({ id, name, checked, onChange, label, ...props }) => {
	return (
		<div className="flex items-center">
			<input
				id={id}
				name={name}
				type="checkbox"
				className="sr-only peer"
				checked={checked}
				onChange={onChange}
				{...props}
			/>
			<label
				htmlFor={id}
				className="relative flex items-center justify-center w-4 h-4 border-2 border-gray rounded cursor-pointer
                   peer-checked:bg-purple peer-checked:border-purple focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple"
			>
				{/* Custom tick mark (SVG) */}
				{checked && (
					<svg
						className="w-3 h-3 text-white pointer-events-none"
						viewBox="0 0 24 24"
						fill="none"
						stroke="currentColor"
						strokeWidth="4"
						strokeLinecap="round"
						strokeLinejoin="round"
					>
						<polyline points="20 6 9 17 4 12"></polyline>
					</svg>
				)}
			</label>
			{label && (
				<label
					htmlFor={id}
					className="ml-[6px] block text-[16px] leading-[21px] text-gray font-medium"
				>
					{label}
				</label>
			)}
		</div>
	);
};

export default CustomCheckbox;
